import { ReactNode } from 'react';
import { css, Theme } from '@emotion/react';
import { Typography, TypographyProps } from 'client/components/Typography';

export interface SectionProps {
  title: string | JSX.Element;
  titleProps?: Partial<TypographyProps>;
  subtitle?: JSX.Element | string;
  subtitleProps?: Partial<TypographyProps>;
  action?: JSX.Element | null;
  children?: ReactNode;
}

export const Section = ({ title, titleProps = {}, subtitle, subtitleProps = {}, action = null, children, ...other }: SectionProps) => (
  <section css={sectionStyle} {...other}>
    <header css={headerStyle}>
      <div>
        <Typography variant="h6" css={titleStyle} {...titleProps}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" component="p" css={subtitleStyle} {...subtitleProps}>
            {subtitle}
          </Typography>
        )}
      </div>
      {action}
    </header>

    <div>{children}</div>
  </section>
);

const sectionStyle = (theme: Theme) => css`
  margin-bottom: 2.2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid ${theme.color.grey[60]};
`;

const headerStyle = (theme: Theme) => css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    left: -66px;
    top: 0;
    background-color: ${theme.color.grey[100]};
  }

  > button {
    flex-shrink: 0;
  }
`;

const titleStyle = css`
  margin-bottom: 4px;
`;

const subtitleStyle = (theme: Theme) => css`
  max-width: 50ch;
  color: ${theme.color.grey[100]};
`;
